import React from 'react';
import { useSelector } from 'react-redux';
import { IReducer } from '../../../../../../redux/configureStore';
import Card from '../../../../../../shared/components/Card';
import {
  CardLabel,
  CardValue,
  LabelAndValueContainer,
} from '../../../../../../shared/components/Card/components/CardComponents';
import theme from '../../../../../../styles/theme';
import checkValue from '../../../../../../utils/values';
import BarChart from '../components/CardWithBarChart/components/BarChart';
import Frame from './components/Frame';

function TibDashboard() {
  const tibFaresState = useSelector((reducer: IReducer) => reducer.tibFares);

  const netErnings =
    tibFaresState.tibsReceived.value - tibFaresState.tibsSent.value;

  return (
    <Frame.Base isActive={tibFaresState.isActive}>
      <Card
        isActive
        gridArea="tibsReceived"
        title="TIBs Recebidas"
        display="flex"
        flexDirection="column"
        padding=""
        justifyContent="flex-start"
        width="100%"
        height="100%"
        backgroundColor="#FFFFFF">
        <LabelAndValueContainer alignCenter>
          <CardLabel>Total</CardLabel>
          <CardValue color={theme.colors.emphasis}>
            {checkValue(tibFaresState.tibsReceived.value).toLocaleString(
              'pt-br',
              {
                style: 'currency',
                currency: 'BRL',
              }
            )}
          </CardValue>
        </LabelAndValueContainer>
        <LabelAndValueContainer alignCenter>
          <CardLabel>IFs Creditadas</CardLabel>
          <CardValue color={theme.colors.emphasis}>
            {tibFaresState.tibsReceived.quantity}
          </CardValue>
        </LabelAndValueContainer>
      </Card>

      <Card
        isActive
        gridArea="tibsPaid"
        title="TIBs Pagas"
        display="flex"
        flexDirection="column"
        padding=""
        justifyContent="flex-start"
        width="100%"
        height="100%"
        backgroundColor="#FFFFFF">
        <LabelAndValueContainer alignCenter>
          <CardLabel>Total</CardLabel>
          <CardValue color={theme.colors.red}>
            {checkValue(tibFaresState.tibsSent.value).toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
          </CardValue>
        </LabelAndValueContainer>
        <LabelAndValueContainer alignCenter>
          <CardLabel>IFs Pagas</CardLabel>
          <CardValue color={theme.colors.red}>
            {tibFaresState.tibsSent.quantity}
          </CardValue>
        </LabelAndValueContainer>
      </Card>
      <Card
        isActive
        gridArea="diference"
        title="Resultado"
        display="flex"
        justifyContent="center"
        height="100%"
        width="100%"
        backgroundColor="#FFFFFF">
        <LabelAndValueContainer alignCenter>
          <CardLabel>Total</CardLabel>
          <CardValue color={theme.colors.red}>
            {checkValue(netErnings).toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
          </CardValue>
        </LabelAndValueContainer>
      </Card>

      <Card
        isActive
        title="TIBs Movimentadas nos Últimos 12 Meses"
        gridArea="lastTwelveMonths"
        display="flex"
        flexDirection="column"
        justifyContent="flex-start"
        width="100%"
        height="100%"
        backgroundColor="#FFFFFF">
        <BarChart
          data={tibFaresState.lastTwelveMonths}
          hasOneData={false}
          firstValueColor={theme.colors.emphasis}
          secondValueColor={theme.colors.red}
          labelForTwoDatas={{
            firstLabel: `Recebidas   `,
            secondLabel: 'Pagas',
          }}
        />
      </Card>
    </Frame.Base>
  );
}

export default TibDashboard;
